<p-dialog
  header="Add Customer"
  [modal]="true"
  [closable]="!addCustomerLoader"
  (onHide)="closeCustomerDialog()"
  [draggable]="false"
  [(visible)]="showCustomerDialog.show"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [showHeader]="false"
>

  <form [formGroup]="userDetailForm" class="grid px-0 mx-0">
    @if (showCustomerDialog.customer) {
      <div class="col-12 px-0 border-bottom-dashed border-size border-clr pb-3">
        <div class="font-medium text-xl">Personal Info</div>
        <div class="grid">
          <div class="col-4">
            <div class="flex flex-column gap-2">
              <label for="contact"
                >Phone No <span class="danger-text">*</span></label
              >

              <input
                pInputText
                id="contact"
                appRegex
                regexType="onlyNumber"
                appMaxLength
                maxlength="11"
                formControlName="cell_num"
                placeholder="e.g 0300 0000000"
              />

              <small
                *ngIf="
                  (userDetailForm.get('cell_num')?.touched ||
                    isFormSubmit === true) &&
                  userDetailForm.get('cell_num')?.hasError('required')
                "
                class="danger-text"
              >
                Phone no is required
              </small>
              <small
                *ngIf="
                  (userDetailForm.get('cell_num')?.touched ||
                    isFormSubmit === true) &&
                  userDetailForm.get('cell_num')?.value.length < 11
                "
                class="danger-text"
              >
                Phone number must be exactly 11 digits
              </small>
            </div>
          </div>
          <div class="col-4">
            <div class="flex flex-column gap-2">
              <label for="name">Name <span class="danger-text">*</span></label>
              <input
                pInputText
                [ngClass]="addCustomerLoader ? 'pointer-none opacity-30' : ''"
                id="name"
                formControlName="first_name"
                placeholder="e.g User"
              />
              <small
                *ngIf="
                  (userDetailForm.get('first_name')?.touched ||
                    isFormSubmit === true) &&
                  userDetailForm.get('first_name')?.hasError('required')
                "
                class="danger-text"
              >
                Name is required</small
              >
            </div>
          </div>
          <div class="col-4">
            <div class="flex flex-column gap-2">
              <label for="email">Email</label>
              <input
                [ngClass]="addCustomerLoader ? 'pointer-none opacity-30' : ''"
                pInputText
                id="email"
                formControlName="email"
                placeholder="e.g User@gmail.com"
              />
              <small
                *ngIf="
                  (userDetailForm.get('email')?.touched ||
                    isFormSubmit === true) &&
                  userDetailForm.get('email')?.errors
                "
                class="danger-text"
                >Invalid email format</small
              >
            </div>
          </div>
          <div class="col-4">
            <div class="flex flex-column gap-2">
              <label for="name">Gender</label>
              <p-dropdown
                [options]="genderArray"
                appendTo="body"
                optionLabel="option"
                [ngClass]="addCustomerLoader ? 'pointer-none opacity-30' : ''"
                placeholder="Select gender"
                formControlName="gender"
                class="w-full"
                styleClass="w-full"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="flex flex-column gap-2">
              <label for="dob">DOB</label>
              <p-calendar
                id="dob"
                [ngClass]="addCustomerLoader ? 'pointer-none opacity-30' : ''"
                formControlName="date_birth"
                appendTo="body"
                [maxDate]="this.currentDate"
                [disabledDates]="[this.currentDate]"
                placeholder="MM/DD/YYYY"
              />
            </div>
          </div>
        </div>
      </div>
    }
    @if (showCustomerDialog.address) {
      <div class="col-12 px-0">
        <div class="flex justify-content-between">
          <div class="font-medium text-xl">Address</div>

          @if (
            !addCustomerLoader &&
            showCustomerDialog.customer &&
            showCustomerDialog.address &&
            placeOrderObj?.order_type_id !== 3
          ) {
            <div class="flex gap-2">
              <div
                (click)="showAddressFeild()"
                [pTooltip]="!showAddressFeilds ? 'Show' : 'Hide'"
                tooltipPosition="bottom"
                class="border-round-sm py-2 px-2 border-1 border-clr cursor-pointer flex align-items-center justify-content-center"
              >
                <i
                  [ngClass]="
                    !showAddressFeilds
                      ? 'pi pi-plus text-lg'
                      : 'pi pi-minus text-lg'
                  "
                ></i>
              </div>
            </div>
          }
        </div>

        <div class="col-4">
          <div class="flex flex-column gap-2">
            <label for="addressType"
              >Address Type <span class="danger-text">*</span></label
            >
            <div
              class="flex flex-wrap gap-2"
              [ngClass]="addCustomerLoader ? 'pointer-none opacity-30' : ''"
              id="addressType"
            >
              <div
                *ngFor="let type of addressType"
                class="flex align-items-center"
              >
                <input
                  type="radio"
                  formControlName="address_type"
                  [value]="type.id"
                  [id]="'address_type_' + type.id"
                  class="mr-2"
                />
                <label [for]="'address_type_' + type.id">{{
                  type.option
                }}</label>
              </div>
            </div>
            <small
              *ngIf="
                (userDetailForm.get('address_type')?.touched || isFormSubmit) &&
                userDetailForm.get('address_type')?.errors
              "
              class="danger-text"
              >Address type is required</small
            >
          </div>
        </div>
        <div class="col-12">
          <div class="flex flex-column gap-2">
            <label for="street"
              >Address
              <span class="danger-text">*</span>
            </label>
            <input
              appNoExtraWhitespace
              [ngClass]="addCustomerLoader ? 'pointer-none opacity-30' : ''"
              pInputText
              id="street"
              formControlName="street"
              placeholder="Address"
            />
            <small
              *ngIf="
                (userDetailForm.get('street')?.touched ||
                  isFormSubmit === true) &&
                userDetailForm.get('street')?.errors
              "
              class="danger-text"
              >Address is required</small
            >
          </div>
        </div>
        @if (showAddressFeilds) {
          <div class="grid">
            @if (true) {
              <div class="col-12">
                <div class="flex flex-column gap-2">
                  <label>Location</label>

                  <input
                    pInputText
                    formControlName="location"
                    #search
                    placeholder="e.g City, Province"
                  />

                   <!-- Autocomplete dropdown -->
                  <div
                    *ngIf="predictions.length > 0"
                    class="autocomplete-panel"
                  >
                    <div
                      class="autocomplete-item"
                      *ngFor="let p of predictions"
                      (click)="onPredictionSelect(p)"
                    >
                      <div class="text">
                        <div class="main-text">
                          {{ p.structured_formatting.main_text }}
                        </div>
                        <div class="secondary-text">
                          {{ p.structured_formatting.secondary_text }}
                        </div>
                      </div>
                    </div>
                   </div>

                  <!-- Map Container -->
                  <div #mapContainer class="location-map"></div>
                </div>
              </div>
            }

            @if (userData.is_order_by_town === 1) {
              <div class="col-4">
                <div class="flex flex-column gap-2">
                  <label for="town"
                    >Town <span class="danger-text">*</span></label
                  >
                  <p-dropdown
                    [options]="townsList"
                    appendTo="body"
                    id="town"
                    [ngClass]="
                      addCustomerLoader ? 'pointer-none opacity-30' : ''
                    "
                    formControlName="town"
                    optionLabel="town_name"
                    placeholder="Select town"
                    class="w-full"
                    styleClass="w-full"
                    [filter]="true"
                    filterBy="town_name"
                    filterPlaceholder="Search..."
                    (onChange)="getSelectedBlock($event)"
                  />
                  <small
                    *ngIf="
                      (userDetailForm.get('town')?.touched ||
                        isFormSubmit === true) &&
                      userDetailForm.get('town')?.errors
                    "
                    class="danger-text"
                    >Town type is required</small
                  >
                </div>
              </div>

              <div class="col-4">
                <div class="flex flex-column gap-2">
                  <label for="block"
                    >Block <span class="danger-text">*</span></label
                  >
                  <!-- -->
                  <p-dropdown
                    [options]="BlockNameList"
                    appendTo="body"
                    id="block"
                    optionLabel="block_name"
                    formControlName="block"
                    placeholder="Select block"
                    class="w-full"
                    styleClass="w-full"
                    [filter]="true"
                    filterBy="block_name"
                    filterPlaceholder="Search..."
                    (onChange)="onBlockSelect($event)"
                    [ngClass]="
                      addCustomerLoader || !userDetailForm.value?.town?.id
                        ? 'pointer-none opacity-30'
                        : ''
                    "
                  />
                  <small
                    *ngIf="
                      (userDetailForm.get('block')?.touched ||
                        isFormSubmit === true) &&
                      userDetailForm.get('block')?.errors
                    "
                    class="danger-text"
                    >Block is required</small
                  >
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        label="Cancel"
        [disabled]="addCustomerLoader"
        class="natural1-bg primary-text py-2 px-3"
        (click)="closeCustomerDialog()"
      ></button>
      <button
        pButton
        [loading]="addCustomerLoader"
        [disabled]="addCustomerLoader"
        label="Save"
        class="primary-bg white-text py-2 px-4"
        (click)="onCustomerFormSave(userDetailForm)"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<!-- address confirm dialogue -->
<!-- <p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '475px' }"
  styleClass="dialog-radius"
>
  <div class="flex justify-content-center p-4">
    <div class="flex justify-content-between">
      <span class="font-bold white-space-nowrap fs-24 fw-600">
        Are You Sure?
      </span>
      <span
        class="body-bg radius-4 flex justify-content-center align-items-center icon cursor-pointer"
        (click)="close()"
        pTooltip="Close"
        tooltipPosition="bottom"
      >
        <i class="pi pi-times primary-text fs-10"></i>
      </span>
    </div>
  </div>
  <div class="flex justify-content-center flex-column align-items-center">
    <div>
      <img src="assets/Svgs/questionMark.svg" alt="" />
    </div>
    <div class="fs-14 fw-400 mt-4">
      You are adding address in
      <span class="fw-600 danger-text">Takeaway</span> order.
    </div>
    <div class="fs-14 fw-400 mt-1">Do you want to conitnue?</div>
  </div>
  <div class="flex justify-content-center gap-3 mt-3">
    <div
      class="pl-1 pr-1 cpy-12 natural1-bg radius-6 w-full cursor-pointer"
      (click)="addAddressForTakeaway()"
    >
      <div class="flex justify-content-center">
        <i class="pi pi-check" style="color: green"></i>
        <span class="fw-600 fs-14 primary-text ml-2">Yes</span>
      </div>
    </div>
    <div
      class="pl-1 pr-1 cpy-12 lightDanger-bg radius-6 w-full cursor-pointer"
      (click)="close()"
    >
      <div class="flex justify-content-center">
        <span><i class="pi pi-times primary-text" style="color: red"></i></span>
        <span class="fw-600 fs-14 danger-text ml-2">No</span>
      </div>
    </div>
  </div>
</p-dialog> -->
<!-- address confirm dialogue -->
